import { memo } from 'react'
import { Popup, Text } from 'common-components'
import { THUNDER_ICON } from 'consts/mediaUrls'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import * as Styled from './styled'
import { useResponsive } from 'hooks/useResponsive'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { CrownIcon } from 'containers/SubSidebar/styled'

interface IProps {
  isOpen: boolean
  isFreeUser: boolean
  hasInsufficientCredits: boolean
  onClose: () => void
  onConfirm: () => void
  credits: number
}

const PowerModePopup = ({
  isOpen,
  isFreeUser,
  hasInsufficientCredits,
  onClose,
  onConfirm,
  credits
}: IProps) => {
  const isMobile = useResponsive(MOBILE_SIZE_BREAKPOINT)

  return (
    <Popup isOpen={isOpen} onClose={onClose}>
      <Styled.Container>
        <Styled.TextBlock>
          <Text
            type={isMobile ? 'h1' : 'header'}
            fontWeight="700"
            color="secondaryDark"
            align="center"
          >
            {translate(T.POWER_MODE_GENERATING_TITLE)}
          </Text>
          <Text type="h2" color="secondaryDark" align="center">
            {translate(
              isFreeUser
                ? T.POWER_MODE_GENERATING_DESCRIPTION_FREE
                : T.POWER_MODE_GENERATING_DESCRIPTION
            )}
          </Text>
        </Styled.TextBlock>
        <Styled.ButtonsWrapper>
          <Styled.WaitButton type="secondary" onClick={onClose}>
            {translate(T.WAIT_LABEL)}
          </Styled.WaitButton>
          <Styled.ConfirmButton
            type="primary"
            onClick={onConfirm}
            $isPremium={hasInsufficientCredits}
          >
            {isFreeUser ? (
              translate(T.UPGRADE)
            ) : (
              <>
                {hasInsufficientCredits && <CrownIcon />}
                {translate(T.TURN_ON_POWER_MODE_LABEL)}
                <Styled.CreditsBadge>
                  <Styled.ThunderIcon src={THUNDER_ICON} alt="credits" />
                  {credits}
                </Styled.CreditsBadge>
              </>
            )}
          </Styled.ConfirmButton>
        </Styled.ButtonsWrapper>
      </Styled.Container>
    </Popup>
  )
}

export default memo(PowerModePopup)
